import useDrawerContext from '@contexts/drawerContext'
import { SwipeableDrawer } from '@mui/material'

const slotProps = {
  paper: {
    style: {
      backgroundColor: 'transparent',
    }
  },
  backdrop: {
    style: {
      backgroundColor: 'rgba(255,255,255,0.1)',
    }
  }
}

const BottomDrawer = () => {
  const { bottomDrawerContents, closeBottomDrawer, isBottomDrawerOpen } = useDrawerContext()
  const isContentFunctional = typeof bottomDrawerContents.current === 'function'

  return (
    <SwipeableDrawer
      // Silences warning about required onOpen
      onOpen={() => {}}
      anchor='bottom'
      // WARNING: we need disableSwipeToOpen because setting it to false causes an invisible swipeable element
      //          to appear at the bottom of the page, and it messes with the navbar big time.
      disableSwipeToOpen
      slotProps={slotProps}
      ModalProps={{ keepMounted: false, }}
      open={isBottomDrawerOpen}
      onClose={closeBottomDrawer}>
      <div style={{ position: 'relative' }}>
        {isContentFunctional
          ? bottomDrawerContents.current()
          : bottomDrawerContents.current
        }
      </div>
    </SwipeableDrawer>
  )
}

export default BottomDrawer
